import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "order-main"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_list = _resolveComponent("van-list");
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_pull_refresh, {
    modelValue: $setup.refreshing,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.refreshing = $event),
    onRefresh: $setup.onRefresh
  }, {
    default: _withCtx(() => [_createVNode(_component_van_list, {
      loading: $setup.loading,
      "onUpdate:loading": _cache[0] || (_cache[0] = $event => $setup.loading = $event),
      finished: $setup.finished,
      "finished-text": "没有更多了",
      onLoad: $setup.onLoad
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, item => {
        return _openBlock(), _createBlock(_component_van_cell, {
          key: item,
          title: item.msg,
          center: "",
          value: item.created_at,
          label: item.price
        }, null, 8, ["title", "value", "label"]);
      }), 128))]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"])]),
    _: 1
  }, 8, ["modelValue", "onRefresh"])]);
}